import { IApplicationState } from '../../types/redux';

export const getAllPromos = (state: IApplicationState) => {
  return state.newbuilding.promoInfos || [];
};
